/**
 * @author Punit Vajpeyi <punit@wemotiveforge.com>
 */

import React from 'react';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Form, Button, Checkbox, Input, Layout, Typography } from 'antd';
import {connect} from 'react-redux';
import {Redirect} from "react-router-dom";
import {ROUTE_ACTIONS, STATIC_URLS, ACTIONS} from '../../../../utils/Constants';
import './ForceResetPassword.css';
import logo from '../../../../assets/logo.png';
import {changePasswordRequest} from "../../AuthenticationApiActions";
import UtilHelper from "../../../../utils/UtilHelper";
import CustomFooter from "../../../Dashboard/components/CustomFooter/CustomFooter";
import GenaLoader from "../../../../utils/components/GenaLoader/GenaLoader";
// import appLogo from '../../../../assets/icons/genascreen-logo.png'
import appLogo from '../../../../assets/icons/genascreen-logo-white.png'
import { LockOutlined } from '@ant-design/icons';
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon'

const {Content, Header, Footer} = Layout;
const FormItem = Form.Item;

/*
 * Form to update the password of the user.
 * This component is shown only when the current password is temporary password
 */
class ForceResetPasswordForm extends React.Component {

  hideLoader = () => {
    this.setState({showLoader: false});
  };

  /**
   * This method is triggered when form is submitted by the user
   * @param e
   */
  handleSubmit = values => {
    // e.preventDefault();

    this.setState({submitClicked: true}, () => {
      // this.props.form.validateFields((err, values) => {
        // if (!err) {
          if (this.state.termsAndConditionSelected) {
            this.setState({showLoader: true}, () => {
              values.userId = this.props.loggedInUser.id;
              this.props.onPasswordChange(values).then(res => {
              }, err => {
                this.hideLoader();
              });
            });
          } else {
          }
        // }
      // });
    });
  };
  /**
   * This method is used to verify if the password are
   * @param rule
   * @param value
   * @param callback
   */
  checkPassword = (rule, value, callback) => {
    if (value && value !== this.props.form.getFieldValue('password')) {
      callback("The passwords don't match");
    } else {
      callback();
    }
  };
  /**
   * Called when user clicks on accept terms and condition policy
   * @param e
   */
  acceptTermsCondition = e => {
    this.setState({termsAndConditionSelected: e.target.checked});
  };

  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      termsAndConditionSelected: false,
      submitClicked: false,
      showLoader: false
    };
  }

  /**
   * Render the UI of the reset password form
   * @returns {XML}
   */
  render() {
    // const {getFieldDecorator} = this.props.form;

    const fieldValidationRules = {
      password: {
        rules: [
          {required: true, message: "Please input your new password"},
          {validator: UtilHelper.validateBlankSpaces},
          {validator: UtilHelper.validatePassword}
        ]
      },
      newPassword: {
        rules: [
          {required: true, message: "Please re-enter your new password"},
          {validator: UtilHelper.validateBlankSpaces},
          {validator: this.checkPassword, message: "Password mismatch"}
        ]
      },
      acceptCondition: {
        rules: []
      },
    };


    if (this.props.loggedInUser && !this.props.loggedInUser.isSystemGeneratedPassword) {
      // return (<Redirect to='/search' />);
      // if (this.props.loggedInUser && !this.props.loggedInUser.isSurveySubmitted) {
      //   return (<Redirect to={ROUTE_ACTIONS.SURVEY}/>);
      // } else {
        if(this.props.currentRole && this.props.currentRole.isSuperAdmin)
          return (<Redirect to={ROUTE_ACTIONS.SETTINGS} />);
        else
          return (<Redirect to={ROUTE_ACTIONS.SEARCH} />);
      // }
    } else {
      return (
        <Layout className="forgot-password-layout">
          <Header className="forgot-password-header">
          {/* Logo on the Left */}
          <img src={appLogo} alt='Application Logo' style={{ height: '48px' }} />
          {/* <Button className="btn" ghost={true} href="/contact-us">
            Contact
            <MailFilled />
          </Button> */}
        </Header>
          <Content className="forgot-password-content">
            <div className='forgot-password-container' style={{ width: '400px', backgroundColor: '#FFFFFF' }}>
              <div className="forgot-password-container-header" style={{ padding : "40px" }} >
                {/* <div style={{ textAlign: 'center' }}><img src={appLogo} alt='Application Logo' style={{ height: '60px' }} /></div> */}
                {/* <div className="flex-vertical">
                  <Typography.Title className="flex-vertical" style={{ gap: '4px', marginBottom: 0 }} level={2}>
                    <LockOutlined />
                    Change Password
                  </Typography.Title>
                </div> */}
                <div className="flex-vertical-gap-1" style={{ alignItems: "center" }}>
                  {/* <LockOutlined style={{ fontSize: '32px' }} /> */}
                  <CustomIcon name="LockClosed" width={48} height={48} />
                  <Typography.Title style={{ margin: 0 }} level={2}>
                    Change Password
                  </Typography.Title>
                </div>
                <Form form={this.props.form} layout="vertical" style={{ width: '100%', padding: '0px', backgroundColor: 'transparent' }} onFinish={this.handleSubmit}>
                  {/* <FormItem>
                    <div className='application-logo-img-div'>
                      <img className='application-logo-img' src={logo} alt="Loading..."/>
                    </div>
                  </FormItem> */}
                  <Form.Item name='password' label="New Password" rules={fieldValidationRules.password.rules}>
                    <Input type="password" placeholder="Enter new password"/>
                  </Form.Item>
                  <Form.Item name='newPassword' label="Re-enter New Password" rules={fieldValidationRules.newPassword.rules}>
                  <Input type="password" placeholder="Re-enter new password"/>
                  </Form.Item>
                  <Form.Item name="acceptCondition" rules={fieldValidationRules.acceptCondition.rules}>
                    <div className="flex-horizontal-gap-2">
                      <Checkbox onChange={this.acceptTermsCondition}></Checkbox>
                      <span>I accept the <a href={STATIC_URLS.TERMS_OF_USAGE} target='_blank' rel="noopener noreferrer">terms and conditions</a></span>
                    </div>
                  </Form.Item>
                  {
                    this.state.submitClicked && !this.state.termsAndConditionSelected ?
                      <span
                        className="error-terms-condition-not-selected">Please accept the terms and conditions</span> : ''
                  }

                  <FormItem>
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      >
                      Set Password
                      <CustomIcon name="LineArrowRight" />
                    </Button>
                  </FormItem>
                </Form>
              </div>
            </div>

            <GenaLoader showLoader={this.state.showLoader}/>
          </Content>
          {/* <Footer>
            <CustomFooter/>
          </Footer> */}
        </Layout>
      )
    }
  }

}

let FirstTimeLogin = (props) => {
  const [form] = Form.useForm();
  return <ForceResetPasswordForm form={form} {...props} />;
};

const mapStateToProps = state => {
  return {
    loggedInUser: state.auth.loggedInUser,
    currentRole: state.auth.currentRole
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onPasswordChange: (data) => {
      return dispatch(changePasswordRequest(data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    }
  }
};

FirstTimeLogin = connect(
  mapStateToProps,
  mapDispatchToProps
)(FirstTimeLogin);


export default FirstTimeLogin;
